module.exports = __webpack_public_path__ + "img/identity-success.4e6a8387.png";